import { Button, Callout } from 'frosted-ui';
import { ExclamationTriangle16 } from '@frosted-ui/icons';

/**
 * A load that failed, said as a failure: never as "nothing here". `what` reads
 * after "Couldn't load", e.g. "your results".
 */
export default function LoadFailed({ what, onRetry }: { what: string; onRetry: () => void }) {
  return (
    <Callout.Root color="red" role="alert">
      <Callout.Icon>
        <ExclamationTriangle16 />
      </Callout.Icon>
      <Callout.Text>
        Couldn't load {what}. Nothing has changed.{' '}
        <Button type="button" variant="ghost" size="1" onClick={onRetry}>
          Try again
        </Button>
      </Callout.Text>
    </Callout.Root>
  );
}
